

const dataCatalogSystemAlertLog={
    "id": "1001",
    "alertName": "API test ",
    "systemAlertId": "1001",
    "unitId": "1001",
    "driverId": "1001",
    "driverName": "1001",
    "type": "Speed",
    "jsonData": "{\"triggerSpeed\":55,\"triggerPostedSpeed\":10,\"operatorAnd\":\"False\"}",
    "severity": "Low",
    "details": null,
    "buildSummary": "Speed over 88 KPH. and Posted Speed over 16 KPH"
  }

 const dataCatalogDeviceReading={
    "driverId": "0",
    "driverName": "NA",
    "deviceLabel": "Example",
    "make": "Ford",
    "model": "Express",
    "vin": "1FTYR2YM5GKA83791",
    "year": "2016",
    "unitTime": "1697663247000",
    "eventCode": "3",
    "eventName": "Drive",
    "latitude": 42.436675,
    "longitude": -123.296949,
    "engineHours": null,
    "engineOdometer": null,
    "starterSupported": "false",
    "starterDisabled": true,
    "dtc": null,
    "desiredStarterState": "Enable",
    "heading": "49",
    "serverTime": "1697663247000",
    "address": {
      "address": "Grants Pass Parkway",
      "city": "Grants Pass",
      "formatted": "Grants Pass Parkway, Grants Pass, Oregon, United States",
      "state": "Oregon",
      "zip": "",
    },
    "ecuEngineHours": "0.0",
    "ecuEngineOdometer": "77189.2",
    "ecuVin": "1FTYR2YM5GKA83791",
    "ecuSpeed": "80",
    "unitType": "L2000C",
    "landmark_id": null,
    "landmarkname": null,
    "deviceData": "{}",
    "temperatures": "{}"
}

const dataCatalogDriver={
    "id": 1001,
    "name": "Driver Example",
    "timezoneId": 82,
    "languageId": 82,
    "contactInfo": 82664,
    "status": 823,
    "tagIds": "-99",
    "defaultTab": "map"
}

const dataCatalogUnit={
    "id": 10001,
    "label": "Unit Example",
    "esn": "68B112440092",
    "imei": "68B112440092",
    "driverId": 0,
    "driverName": null,
    "useEcuOdometer": false,
    "offsetEngineOdometer": 0,
    "offsetEcuEngineOdometer": 0,
    "useEcuEngineHours": false,
    "offsetEngineHours": 0,
    "offsetEcuEngineHours": 0,
    "useEcuSpeed": false,
    "jbus": 0,
    "vbus": 0,
    "vehicleStatus": 200001986,
    "deviceCategory": "Fleet",
    "unitVersionId": 102,
    "unitVersionProduct": "68 Series",
    "odometerEnable": true,
    "hoursEnable": true,
    "starter": 1,
    "desiredStarterState": "Enable",
    "typeId": 29,
    "type": "geometris",
    "supportedOutputs": 1,
    "supportedInputs": 1
}

const dataCatalogVehicleInformation={
    "unitId": 10001,
    "vin": "5XYP5DHC7LG043822",
    "make": "KIA",
    "model": "Telluride",
    "year": 2020,
    "engine": "3.8",
    "mpgHighway": 0,
    "mpgCity": 0
}

const dataCatalogWorkOrder = {
  id: 197,
  customerId: 123,
  workOrderTypeId: 123,
  description: "Oil change and brake inspection",
  driverId: 200024054,
  scheduledDate: "2025-05-29T15:52:02.000Z",
  estimatedDurationMins: 20,
  customerContactId: 266,
  severity: "Low",
  dynamicFormId: 180,
  statusId: 123,
  statusUpdatedOn: "2025-04-30T16:15:44.049Z",
};

export const dataCatalogSamples = {
  dataCatalogSystemAlertLog,
  dataCatalogDeviceReading,
  dataCatalogDriver,
  dataCatalogUnit,
  dataCatalogVehicleInformation,
  dataCatalogWorkOrder
}

